import { IconCircle, IconCircleCheckFilled } from '@tabler/icons-react';

/**
 * The account password rules (UserManagement: 8+ characters, upper and lower case, a number and
 * a symbol), checked live under the password field so members see what's missing before they
 * submit instead of after a failed attempt.
 */
export const PASSWORD_RULES: { key: string; label: string; test: (pw: string) => boolean }[] = [
  { key: 'len', label: 'At least 8 characters', test: (pw) => pw.length >= 8 },
  { key: 'upper', label: 'A capital letter', test: (pw) => /[A-Z]/.test(pw) },
  { key: 'lower', label: 'A small letter', test: (pw) => /[a-z]/.test(pw) },
  { key: 'digit', label: 'A number', test: (pw) => /[0-9]/.test(pw) },
  { key: 'symbol', label: 'A symbol, like ! or #', test: (pw) => /[^A-Za-z0-9]/.test(pw) },
];

export function passwordMeetsRules(pw: string): boolean {
  return PASSWORD_RULES.every((r) => r.test(pw));
}

export function PasswordRules({ password, id }: { password: string; id?: string }) {
  return (
    <ul className="rides-rules" id={id} aria-label="What it needs">
      {PASSWORD_RULES.map((r) => {
        const ok = r.test(password);
        return (
          <li key={r.key} data-ok={ok}>
            {ok ? <IconCircleCheckFilled size={18} aria-hidden="true" /> : <IconCircle size={18} aria-hidden="true" />}
            <span>{r.label}<span className="sr-only">{ok ? ' (done)' : ' (still needed)'}</span></span>
          </li>
        );
      })}
    </ul>
  );
}
